import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-popup-interactive-admin-config',
  templateUrl: './popup-interactive-admin-config.component.html',
  styleUrls: ['./popup-interactive-admin-config.component.scss']
})
export class AtwPopupInteractiveAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() id_subproject : any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    }
  ];
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };

  effect_hover = [];
  effect_hover_data: any = {}
  id_subproject: any = "";
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'Từ trái trên sang phải dưới',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'Từ phải trên sang trái dưới',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'Từ trái dưới sang phải trên',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'Từ phải dưới sang trái trên',
      deg: '315deg',
    },
  ];
  block_hover = [];
  customize = [];
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  // Xử lý lấy các block
  getBlockHover() {
    // this.vhQueryAutoWeb.getBlocks_byFields({})
    this.vhQueryAutoWeb.getBlocks_byFields({ type: { $eq: `popup_detail_${this.objectChoosing.main_sector}`}})
      .then((blocks: any) => {
        this.block_hover = blocks;
      })
  }

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    public vhEventMediator: VhEventMediator, 
    public functionService: FunctionService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    this.getBlockHover(); 
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  ngOnDestroy() {
  }

  /**
   * Vị trí khối hộp thoại so với chữ
   * @param position : vị trí
   */
  handleSetBlockPosition(position) {
    switch (position) {
      case 'left':
        this.class['text__hover']['left'] = '0px';
        this.class['text__hover']['right'] = 'auto';
        this.class['text__hover']['transform'] = 'none';
        break;
      case 'center':
        this.class['text__hover']['left'] = '50%';
        this.class['text__hover']['right'] = 'auto';
        this.class['text__hover']['transform'] = 'translateX(-50%)';
        break;
      case 'right':
        this.class['text__hover']['left'] = 'auto';
        this.class['text__hover']['right'] = '0px';
        this.class['text__hover']['transform'] = 'none';
        break;
      default:
        this.class['text__hover']['left'] = '0px';
        this.class['text__hover']['right'] = 'auto';
        this.class['text__hover']['transform'] = 'none';
    }

    this.updateObject();
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image'].gradient_check) {
      this.class['text__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['text__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text__content']['background-image'] = 'none';
      this.class['text__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text__content']['-webkit-background-clip'] = 'unset';
    }

    // gradient cho kiểu uốn cong
    if (this.config['curve']['isCurve']) {
      this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
      this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
      this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    }

    this.updateClass();
    this.updateConfig();
  }

  openbgGradient() {
    document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
    })
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then(
  //       (bool) => {
          
  //       },
  //       (error) => {
  //         console.error(error);
  //       }
  //     );
  // }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
